import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { graphql } from 'gatsby';
import React from 'react';
import Layout from '../components/layout';
import SEO from '../components/seo';
import postStyles from './styles/blogPost.module.scss';

export const query = graphql`
  query($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }, description: {}) {
      title
      description
      slug
      body {
        json
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`;

const BlogPage = props => {
  const options = {
    renderNode: {
      'embedded-asset-block': node => {
        const alt = node.data.target.fields.title['en-US'];
        const url = node.data.target.fields.file['en-US'].url;
        return (
          <div className={postStyles.postImg}>
            <img src={url} alt={alt} />
          </div>
        );
      },
    },
  };
  return (
    <Layout>
      <SEO
        title={props.data.contentfulBlogPost.title}
        description={props.data.contentfulBlogPost.description}
        includeWebsiteName={false}
        url={`${props.data.site.siteMetadata.siteUrl}/blog/${props.data.contentfulBlogPost.slug}/`}
      />
      <div className={postStyles.post}>
        <h1 className={postStyles.postTitle}>
          {props.data.contentfulBlogPost.title}
        </h1>
        <div className={postStyles.postContent}>
          {documentToReactComponents(
            props.data.contentfulBlogPost.body.json,
            options
          )}
        </div>
      </div>
    </Layout>
  );
};

export default BlogPage;
